// =============================================================================
// AGENT 2 (layout/UX) + AGENT 4 (copy) — EKRAN STARTOWY
// Przekazuje kontrolę do App.tsx poprzez onStart callback.
// =============================================================================

import './StartScreen.css';
import { COPY } from '../../copy/microcopy';
import { useGame } from '../../store/gameStore';
import { BrandBackdrop, BrandLogo } from '../../ui';

interface StartScreenProps {
  onStart: () => void;
}

export function StartScreen({ onStart }: StartScreenProps) {
  const { startGame } = useGame();

  const handleStart = () => {
    startGame();
    onStart();
  };

  return (
    <main className="start-screen">
      <BrandBackdrop variant="hero" />

      <section className="start-screen__panel">
        <BrandLogo tone="white" className="start-screen__logo" />

        <video
          className="start-screen__video"
          src="/skompresowany.mp4"
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          aria-hidden="true"
        />

        <h1 className="start-screen__headline">{COPY.start.headline}</h1>
        <p className="start-screen__sub">{COPY.start.subheadline}</p>

        <ul className="start-screen__rules" aria-label={COPY.start.rulesTitle}>
          {COPY.start.rules.map((rule) => (
            <li key={rule}>{rule}</li>
          ))}
        </ul>

        <button className="start-screen__cta" onClick={handleStart}>
          {COPY.start.ctaButton}
        </button>
      </section>
    </main>
  );
}
